var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(-21 -16)",
    fill: "#E99002",
    fillRule: "nonzero",
    fontFamily: "FontAwesome5ProRegular, Font Awesome 5 Pro",
    fontSize: 18
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 21,
    y: 32
  }, "\uF06A"))));
}
export default SvgWarningIco;